import script from "./PrivateRegistry.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrivateRegistry.vue?vue&type=script&setup=true&lang=ts"

import "./PrivateRegistry.vue?vue&type=style&index=0&id=6006ccc4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6006ccc4"]])

export default __exports__